import "../scss/styles.scss";
import PageCommon	from "./pages/PageCommon.js";
import PageDefault	from "./pages/PageDefault.js";
import PageGeneric	from "./pages/PageGeneric.js";
import PageLookupGroup from "./pages/lookup/PageLookupGroup.js";
import PageLookupList from "./pages/lookup/PageLookupList.js";
import PageLookupCustom from "./pages/lookup/PageLookupCustom.js";
import PageLookupDetail from "./pages/lookup/PageLookupDetail.js";
import PageUsersList from './pages/users/PageUsersList.js';
import PageUserDetail from './pages/users/PageUserDetail.js';
import PageDashboard from './pages/dashboard/PageDashboard.js';
import PageUserInfo from './pages/users/PageUserInfo.js';
import PageReferences from './pages/references/PageReferences.js';
import PageNewsList from './pages/editor/PageNewsList.js';
import PageNewsDetail from './pages/editor/PageNewsDetail.js';
import PageFaqList from './pages/editor/PageFaqList.js';
import PageFaqDetail from './pages/editor/PageFaqDetail.js';
import PageDocumentsList from './pages/editor/PageDocumentsList.js';
import PageDocumentsDetail from './pages/editor/PageDocumentsDetail.js';
import PageMediaList from './pages/editor/PageMediaList.js';
import PageMediaDetail from './pages/editor/PageMediaDetail.js';
import PageImportList from './pages/import/PageImportList.js';
import PageImportDetail from './pages/import/PageImportDetail.js';
import PagePrivacyList from './pages/editor/PagePrivacyList.js';
import PagePrivacyDetail from './pages/editor/PagePrivacyDetail.js';
import PageNotificationDetail from './pages/editor/PageNotificationDetail.js';
import PageMobileUsersList from './pages/users/PageMobileUsersList.js';
import PageMobileDetail from './pages/users/PageMobileDetail.js';
import ServiceManager from "./3x1010/services/ServiceManager.js";
import PageSpecialRequestsList from './pages/specialrequests/PageSpecialRequestsList.js';
import PageSpecialRequestsDetail from './pages/specialrequests/PageSpecialRequestsDetail.js';
import PageSalesUsersList from './pages/users/PageSalesUsersList.js';
import PageSaleUserCreate from './pages/users/PageSaleUserCreate.js';

import PageInvoiceList from './pages/invoice/PageInvoiceList.js';
import PageInvoiceSearch from './pages/invoice/PageInvoiceSearch.js';

import PageInvoiceFilterDetail from "./pages/lookup/PageInvoiceFilterDetail.js";
import PageInvoiceFilterList from "./pages/lookup/PageInvoiceFilterList.js";

import PageBrokerUsersList from './pages/users/PageBrokerUsersList.js';
import PageBrokerDetail from './pages/users/PageBrokerDetail.js';

import PageDashboardSubUsersList from './pages/users/PageDashboardSubUsersList.js';
import PageDashboardSubUserDetail from './pages/users/PageDashboardSubUserDetail.js';

import PageDMSDetail from "./pages/dms/PageDMSDetail";
import PageDMSList from "./pages/dms/PageDMSUsersList";
import PageDMSUpload from "./pages/dms/PageDMSUpload";
import PageDMSImportList from "./pages/dms/PageDMSImportList";
import PageDMSImportDetail from "./pages/dms/PageDMSImportDetail";

import PageDeliveriesList from "./pages/delivery/delivery/PageDeliveriesList";
import PageDeliveryDetail from "./pages/delivery/delivery/PageDeliveryDetail";

import PageTransportersList from "./pages/delivery/transporters/PageTransportersList";
import PageTransporterDetail from "./pages/delivery/transporters/PageTransporterDetail";

export default class FactoryManager {

	static factory(cls) {
		return new FactoryManager.classes[cls]();
	}

}
// PAGINE
FactoryManager.classes = {
	PageCommon, PageDefault, PageGeneric,
	PageLookupGroup, PageLookupList, PageLookupDetail,
	PageUsersList, PageUserDetail,
	PageDashboard,
	PageUserInfo,
	PageReferences,
	PageNewsList, PageNewsDetail,
	PageFaqList, PageFaqDetail,
	PageDocumentsList, PageDocumentsDetail,
	PageMediaList, PageMediaDetail,
	PageImportList, PageImportDetail,
	PagePrivacyList, PagePrivacyDetail,
	PageNotificationDetail,
	PageMobileUsersList, PageMobileDetail,
	PageSpecialRequestsList, PageSpecialRequestsDetail,
	PageSalesUsersList, PageSaleUserCreate,
	PageInvoiceSearch, PageInvoiceList,
	PageLookupCustom,
	PageInvoiceFilterDetail, PageInvoiceFilterList,
	PageBrokerUsersList, PageBrokerDetail,
	PageDashboardSubUsersList, PageDashboardSubUserDetail,

	PageDMSList, PageDMSDetail, PageDMSUpload, PageDMSImportList, PageDMSImportDetail,

	PageDeliveriesList,
	PageTransporterDetail,
	PageTransportersList,
	PageDeliveryDetail
};

// ALTRE CLASSI ESPORTATE ESPLICITAMENTE
window.Class = {};
window.Class.ServiceManager = ServiceManager;
window.Class.PageCommon = PageCommon; 